import * as jf from 'joiful';
import { CaseStatus } from './case-status.enum';
import { CaseType } from './case-type.enum';

export class CaseHeaderModel {
  @(jf.string().required().max(255))
  public id: string;
  @(jf.string().required().max(255))
  public accountId: string;
  @(jf.string().required().max(255))
  public caseNumber: string;
  @(jf.string().required().max(255))
  public userId: string;
  @(jf.string().required().max(255))
  public type: CaseType;
  @(jf.string().required().max(255))
  public status: CaseStatus;
  @(jf.string().required().max(255))
  public subject: string;
  @(jf.date().required())
  public createdAt: Date;
  @jf.string()
  public returnOrderNumber: string;

  // for warranty type
  @jf.boolean()
  public isRefund?: boolean;
  @(jf.string().max(255))
  public refundStatus?: string;
  @(jf.string().max(255))
  public reason?: string;

  // for return type
  @jf.number()
  public itemsTotalQuantity?: number;
  @jf.number()
  public itemsOpen?: number;
  @jf.number()
  public itemsApproved?: number;
  @jf.number()
  public itemsDeclined?: number;
  @(jf.string().max(255))
  public description?: string;

  // @(deprecated)
  @(jf.string().max(255))
  public contactId?: string;

  // @(deprecated)
  @(jf.string().max(255))
  public erpId?: string;

  // TODO: Remove _id once all the failed messages are processed from the service bus
  @(jf.string().optional().max(255))
  public _id?: string;
}
